import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { PanelLocationsService } from 'src/app/features/locations-map/services/Panel-Locations.service';
import { AssignmentService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/Assigment.service';
import { NavHeaderService } from '../../../nav-menu/services/nav-header.service';
import { LayerService } from 'src/app/features/locations-map/services/Layers.service';
import { NotificationsToastService } from 'src/app/features/shared/services/Notifications-Toast.service';

@Component({
  selector: 'screen-blocker',
  templateUrl: './screen-blocker.component.html',
  styleUrls: ['./screen-blocker.component.css']
})
export class ScreenBlockerComponent {
  public isBlocking: boolean = false;
  public message : string = "";

  subscription_GetIsAssigning: Subscription;
  constructor(private assignmentService: AssignmentService,
    private navHeaderService: NavHeaderService,
    private layerService: LayerService,
    private notificationsToastService: NotificationsToastService,
  ){
  }

  ngOnInit(): void {
    this.subscription_GetIsAssigning = this.assignmentService.getAssigning().subscribe(isAssigning => {
      console.log("isAssigning", isAssigning);
      if (isAssigning) {
        this.assignmentStarted();
      }else{
        this.assignmentStoped();
      }
    });
  }

  ngOnDestroy(): void {
    if(this.subscription_GetIsAssigning)
      this.subscription_GetIsAssigning.unsubscribe();
  }

  assignmentStarted() {
    this.isBlocking = true;
    this.message = "Asignando servicios, por favor espere...";
    this.layerService.closeAllLayers();
    this.navHeaderService.closeAllPanels();
    this.assignmentService.setAssignmentGeoJsons();
    this.assignmentService.assignmentShow();
  }

  assignmentStoped(){
    this.isBlocking = false;
    this.message = "";
    this.notificationsToastService.showSuccess("Asignación de servicios","Proceso de asignación de servicios finalizado");
    this.layerService.isInternalLayersVisible = true;
    this.navHeaderService.setIsLocationSelected(true);
  }
}
